import {
	UPDATE_VIDEO_PROGRESS
} from '../actions/types'

const initialState = {
	videos: {

	}
}

export default (state = initialState, action) => {
	const payload = action.payload;

	switch (action.type) {
		case UPDATE_VIDEO_PROGRESS: {
			const newState = {
				...state
			};
			const curVideo = {...newState.videos[payload.videoKey]};
			curVideo.progress = payload.progress;
			curVideo.uploaded = payload.uploaded;
			curVideo.uploading = payload.uploading;
			newState.videos[payload.videoKey] = curVideo;
			return newState;
		}
		default:
			return state;
	}
}